import React from "react";
import Section1 from "@/pages/sections/section1";
import Section2 from "@/pages/sections/section2";
import Section3 from "@/pages/sections/section3";
import Hero from "@/layout/hero";

const HomePage: React.FC = () => {
  return (
    <>
      <Hero />
      <main id="main-content">
        <Section1 />
        <Section2 />
        <Section3 />
      </main>
    </>
  );
};

export default HomePage;
